import { fetchJson } from 'utils/fetch';

export const getReferencesByType = (type, caseId) =>
  fetchJson(`/pco-manager/pco-case-refs.json?type=${type}&caseId=${caseId}`);

export const getAASTReferencesByType = (type, caseId) =>
  fetchJson(`/pco-manager/aast-case-refs.json?type=${type}&caseId=${caseId}`);



// WEBPACK FOOTER //
// ./src/modules/saas/references/api/index.js